<template>
    <v-layout>
        <patient-navigation/>

        <v-container
            fluid
            container fill-height
        >
            <v-layout align-center justify-center column v-if="init">
                <h1>{{ $t('followUp') }} {{((followUpName === 'Pre-op' || followUpName === 'preop') ? $t('preOp') : followUpName) }} - {{ medicalCaseName }}</h1>
                <h2 class="mb-4">{{ concern === 'patient' ? $t('patient') : $t('doctor')}}</h2>
                <div v-if="status === 'completed'">
                    <v-card-title>
                        <v-layout column mt-4>
                            <v-flex pa-2>
                                <h2>{{$t('followUpCompleted')}}</h2>
                            </v-flex>
                            <v-flex px-2>
                                <span class="title">{{$t('followUpCompletedMessage')}}</span>
                                <p v-if="completedNextUrl">
                                    {{$t('followUpCompletedNextMessage')}}<br>
                                    <a :href="completedNextUrl">{{$t('followUpCompletedNextMessageClickHere')}}</a>
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                </div>
                <template v-else-if="status === 'new' || status === 'started'">
                    <v-layout row align-start justify-center v-if="!startScore && hasRelatedTreatmentWithFollowupDone">
                        <v-flex md12 lg8 m-auto>
                            <v-container fluid grid-list-xs>
                                <v-layout row>
                                    <v-flex grow>
                                        <h4>{{ medicalCaseName == "Gonalgies droites" ? $t('copy_answers_legend_right') : $t('copy_answers_legend_left')  }}</h4>
                                    </v-flex>
                                </v-layout>
                                <v-layout row mt-4 ml-5 mr-5 justify-space-between>
                                    <v-btn color="secondary" text @click="copyAnswers()" :disabled="this.isLoading" :loading="this.isLoading">
                                        {{ $t('copy_answers') }}
                                    </v-btn>

                                    <v-btn color="primary" text @click="start()" :disabled="this.isLoading">
                                        {{ status === 'new' ? $t('start') : $t('continue') }}
                                    </v-btn>
                                </v-layout>
                            </v-container>
                        </v-flex>
                    </v-layout>

                    <v-btn color="primary" v-else-if="!startScore" text @click="start()">
                        {{ status === 'new' ? $t('start') : $t('continue') }}
                    </v-btn>

                    <patient-score-view
                        v-if="startScore"
                        :listener="confirmExit"
                    >
                    </patient-score-view>
                </template>
                <template v-else-if="status === 'incomplete'">
                    <v-btn color="primary" text @click="startCompleteMedicalInfos()" v-if="!startCompletion">
                        {{ $t('completeMedicalInfos') }}
                    </v-btn>
                    <patient-medical-case-form
                        v-if="startCompletion"
                        :listener="confirmExit"
                    >
                    </patient-medical-case-form>
                </template>
            </v-layout>
        </v-container>
    </v-layout>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex';
import PatientScoreView from "../../components/patients/score/PatientScoreView";
import PatientNavigation from "../../components/patients/PatientNavigation";
import PatientMedicalCaseForm from "../../components/patients/medicalCases/PatientMedicalCaseForm";
import axios from 'axios'

export default {
    name: "PatientFollowUp",
    components: {
        PatientMedicalCaseForm,
        PatientNavigation,
        PatientScoreView
    },
    data() {
        return {
            sign: null,
            startScore: false,
            startCompletion: false,
            medicalInfoCompleted: null,
            init: false,
            isLoading: false
        }
    },
    mounted() {
        this.setConcern(this.$route.params.concern)
        this.setSelectedTreatmentId(this.$route.params.treatment_id)
        this.setFollowUpStep(this.$route.params.step_id)
        this.sign = this.$route.params.hash
        this.openFollowUpFromNotification({signature: this.sign, concern: this.concern, axios: axios}).then(response => {
            this.setFollowUpStatus(response.data.follow_up_status);
            this.setFollowUpName(response.data.step.name);
            this.setMedicalCaseName(response.data.follow_up.treatment.medical_case.name);
            this.setCopyRelatedUrl(response.data.copy_related_url);

            if (this.status === 'incomplete') {
                this.setSelectedPatient(response.data.patient)
                this.setFormTegner(response.data.patient.tegner)
                this.setSelectedMedicalCase(response.data.medical_case)
                this.setMedicalCasePostUrl(response.data.medical_case_post_url)
                this.setTegnerUrl(response.data.tegner_post_url)
                this.setAddressUrl(response.data.address_post_url)
                this.setFirmUrl(response.data.firm_post_url)
                this.setJobUrl(response.data.job_post_url)
                this.setDoctorUrl(response.data.doctor_post_url)
                this.setStudyUrl(response.data.study_post_url)
                this.initPatientForms(response.data.patient)
            }
            else {
                this.setCompletedNextUrl(response.data.next_link)
                this.setHasRelatedTreatmentWithFollowupDone(response.data.has_related)
                this.setNextUrl(response.data.next_route)
                this.setLastUrl(response.data.previous_route)
                this.setSelectedFollowUpId(response.data.follow_up.id)

                 if (this.completedNextUrl) {
                    setTimeout(this.redirectToNext,5000)
                }
            }

            this.init = true;

            if(this.status !== 'completed') {
                window.addEventListener('beforeunload', this.confirmExit);
            }

        }).catch(reason => {
            //Stay here..
        })
    },
    computed: {
        ...mapState('treatments', {
            selectedTreatment: state => state.selectedTreatment,
        }),
        ...mapState('medical_cases', {
            medicalCase: state => state.medicalCase,
            medicalCasePostUrl: state => state.medicalCasePostUrl
        }),
        ...mapState('follow_ups', {
            selectedFollowUp: state => state.selectedFollowUp,
            nextUrl: state => state.nextUrl,
            lastUrl: state => state.lastUrl,
            followUpStep: state => state.followUpStep,
            concern: state => state.concern,
            status: state => state.followUpStatus,
            followUpName: state => state.followUpName,
            completedNextUrl: state => state.completedNextUrl,
            hasRelatedTreatmentWithFollowupDone: state => state.hasRelatedTreatmentWithFollowupDone,
            medicalCaseName: state => state.medicalCaseName,
            copyRelatedUrl: state => state.copyRelatedUrl
        }),
        ...mapState('patients', {
            patient: state => state.selectedPatient,
            doctorsForm: state => state.doctorsForm,
        }),

    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.confirmExit);
    },
    methods: {
        ...mapActions('follow_ups', ['openFollowUpFromNotification', 'copyFollowUpFromNotification']),
        ...mapMutations('treatments', [
            'setSelectedTreatmentId'
        ]),
        ...mapMutations('medical_cases', [
            'setSelectedMedicalCase',
            'setMedicalCasePostUrl'
        ]),
        ...mapMutations('patients', [
            'setSelectedPatient',
            'setFormTegner',
            'setTegnerUrl',
            'setAddressUrl',
            'setFirmUrl',
            'setJobUrl',
            'setDoctorUrl',
            'setStudyUrl',
            'initPatientForms'
        ]),
        ...mapMutations('follow_ups', [
            'setSelectedFollowUpId',
            'setFollowUpStatus',
            'setFollowUpName',
            'setMedicalCaseName',
            'setCompletedNextUrl',
            'setHasRelatedTreatmentWithFollowupDone',
            'setNextUrl',
            'setLastUrl',
            'setFollowUpStep',
            'setConcern',
            'setCopyRelatedUrl'
        ]),
        start() {
            this.startScore = true
        },
        startCompleteMedicalInfos() {
            this.startCompletion = true
        },
        confirmExit(event) {
            // Display confirmation dialog when the user attempts to close the browser window
            event.preventDefault();
            event.returnValue = '';
            return '';
        },

        redirectToNext() {
            window.location.href = this.completedNextUrl
        },

        copyAnswers() {
            this.isLoading = true
            this.copyFollowUpFromNotification({signature: this.sign, concern: this.concern, axios: axios}).then(response => {
                this.setCompletedNextUrl(response.data.next_link)
                this.isLoading = false
                window.removeEventListener('beforeunload', this.confirmExit);
                if (this.completedNextUrl) {
                    setTimeout(this.redirectToNext,200)
                }
                else {
                    this.setFollowUpStatus('completed');
                }

            });
        }
    }
}
</script>

<style scoped>

</style>
